import { writeConfigFields } from './settings-fields';

/** `PATCH /client/config/fields`: root `ratings`. */
export const editRatings = async (ratings: string[]): Promise<any> =>
  writeConfigFields({ ratings });
